import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfficeListComponent } from './office-list.component';
import { OfficeListService } from './office-list.service';
import { MaterialModule } from '@fuse/material.module';
import { FlexModule } from '@angular/flex-layout';
 
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexModule
  ],
  declarations: [
    OfficeListComponent
  ],
  providers: [
    OfficeListService
  ]
})
export class OfficeListModule { }
